/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embedding_Error_Space_LimitInputs */



/**
* | output |
* | --- |
* | "This space has used up its embedding allowance on the current plan." |
*
* @param {Embedding_Error_Space_LimitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const embedding_error_space_limit = /** @type {((inputs?: Embedding_Error_Space_LimitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embedding_Error_Space_LimitInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Space hat sein Indexierungskontingent im aktuellen Tarif aufgebraucht.")
	return /** @type {LocalizedString} */ ("This space has used up its embedding allowance on the current plan.")
});